module.exports = __webpack_public_path__ + "media/src/images/certificates/generic_sop_sample-b64d698eec06d1863f764aca4125045c.jpg";